module.exports = __webpack_public_path__ + "static/media/venue.c6ef46b6.png";